export default __webpack_public_path__ + "static/media/blue-dress-pic.02c0da46.png";